import { Injectable, Signal } from '@angular/core';
import { IqEventBusBrokerService } from '@dat/iq-event-bus';
import { isEmpty } from 'lodash';
import { Dashboard, IIqBuilderStateService, TriggerEvent } from '../../models';
import { IqBuilderStateActionsComponentService } from './iq-builder-state-actions-component.service';
import { IqBuilderStateActionsDashboardService } from './iq-builder-state-actions-dashboard.service';
import { IqBuilderStateActionsSectionService } from './iq-builder-state-actions-section.service';
import { IqBuilderStateStatusService } from './iq-builder-state-status.service';

@Injectable({
    providedIn: 'root',
})
export class IqBuilderStateService implements IIqBuilderStateService {
    constructor(
        private readonly _statusState: IqBuilderStateStatusService,
        private readonly _actionDashboard: IqBuilderStateActionsDashboardService,
        private readonly _actionSection: IqBuilderStateActionsSectionService,
        private readonly _eventBroker: IqEventBusBrokerService,
        private readonly _actionComponent: IqBuilderStateActionsComponentService,
    ) {}

    dashboardState(dashboard: Dashboard): Signal<Dashboard> {
        return this._statusState.addDashboard(dashboard);
    }

    dashboardCache(dashboardId: string): Signal<any> {
        return this._statusState.getDashboardCache(dashboardId);
    }

    sectionCache(dashboardId: string, sectionId: string): Signal<any> {
        return this._statusState.getSectionCache(dashboardId, sectionId);
    }

    processActions(events: TriggerEvent[] = [], data: any) {
        events?.forEach?.((evt: TriggerEvent) => {
            if (isEmpty(evt.rules)) return this._eventBroker.dispatch(evt);

            this._eventBroker.dispatch({
                name: 'type:rules:evaluator:run',
                payload: {
                    ...evt,
                    operator: evt.ruleOperator,
                    data
                },
            });
        });
    }

    registerDashboadActions() {
        this._actionDashboard.register();
    }
    registerComponentActions() {
        this._actionComponent.register();
    }
    registerSectionActions() {
        this._actionSection.register();
    }
}
